import { onUnmounted } from 'vue'

interface UseTimeoutReturn {
  set: (fn: () => void, delay: number) => void
  clear: () => void
}

export const useTimeout = (): UseTimeoutReturn => {
  let id: ReturnType<typeof setTimeout> | null = null

  const set = (fn: () => void, delay: number): void => {
    clear()
    id = setTimeout(() => {
      fn()
      id = null
    }, delay)
  }

  const clear = (): void => {
    if (id !== null) {
      clearTimeout(id)
      id = null
    }
  }

  onUnmounted(clear)

  return { set, clear }
}
